import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserService } from '../../services/user-service/user-service';
import { TenantResolverService } from '../../services/tenant-resolver/tenant-resolver';

export const protectedRouteGaurd: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const userService = inject(UserService);
  const tenantResolver = inject(TenantResolverService);

  const userType = tenantResolver.getUserContext().userType;

  if (userType === 'guest') {
    router.navigate(['']);
    return false;
  }

  if (userService.isLoggedIn()) {
    const defaultRoute = userService.getUserDefaultRoute();
    router.navigate([defaultRoute]);
    return false;
  }
  return true;
};

export const guestEntryGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const userService = inject(UserService);
  const tenantResolver = inject(TenantResolverService);

  const userType = tenantResolver.getUserContext().userType;

  if (userType === 'guest') return true;

  if (userService.isLoggedIn()) {
    const defaultRoute = userService.getUserDefaultRoute();
    router.navigate([defaultRoute]);
  }

  router.navigate(['/auth/login']);
  return false;
};

export const guestGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const userService = inject(UserService);
  const tenantResolver = inject(TenantResolverService);

  const userType = tenantResolver.getUserContext().userType;

  if (userType === 'guest' && route.url.toString().indexOf('auth') >= 0) {
    router.navigate(['']);
    return false;
  } else if (userType === 'guest') {
    return true;
  }

  if (userService.isLoggedIn()) {
    const defaultRoute = userService.getUserDefaultRoute();
    router.navigate([defaultRoute]);
    return false;
  }
  return true;
};
